import React from 'react';
import { useCurrency } from '../contexts/CurrencyContext';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

const CurrencySelector = ({ className = "" }) => {
  const { 
    primaryCurrency, 
    secondaryCurrency, 
    activeCurrency, 
    setActiveCurrency,
    getAvailableCurrencies 
  } = useCurrency();

  const availableCurrencies = getAvailableCurrencies();

  // Don't show selector if only one currency
  if (availableCurrencies.length <= 1) {
    return null;
  }

  const handleCurrencyChange = (value) => {
    setActiveCurrency(value);
  };

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <span className="text-sm text-gray-400">Currency:</span>
      <Select value={activeCurrency} onValueChange={handleCurrencyChange}>
        <SelectTrigger className="w-[100px] h-8 bg-gray-800 border-gray-700 text-white">
          <SelectValue />
        </SelectTrigger>
        <SelectContent className="bg-gray-800 border-gray-700">
          {availableCurrencies.map((currency) => (
            <SelectItem 
              key={currency} 
              value={currency}
              className="text-white hover:bg-gray-700"
            >
              {currency}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default CurrencySelector;
